
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'documents-public-ui',
  currentProjectVersion: 'static-1.34372',
  depVersions: {
  "documents-public-ui": "static-1.34372",
  "client-types": "static-1.459",
  "documents-lib": "static-1.34377",
  "emoji-mart": "static-3.4",
  "foundations-theming-specialty": "static-1.2079",
  "googlemaps-react-wrapper": "static-1.3",
  "head-dlb": "static-1.4938",
  "highcharts": "static-8.102",
  "hs-promise-utils": "static-1.5541",
  "hs-test-utils": "static-1.7962",
  "hub-http": "static-1.6168",
  "hubspot-dlb": "static-2.1832",
  "HubStyleTokens": "static-2.11408",
  "I18n": "static-7.1610",
  "jasmine-immutable": "static-1.2966",
  "jasmine-runner": "static-1.6417",
  "lodash": "static-1.3",
  "quartz": "static-1.6949",
  "react": "static-7.184",
  "react-dlb": "static-1.77",
  "react-dnd": "static-3.19",
  "react-dnd-html5-backend": "static-3.7",
  "react-redux": "static-7.70",
  "react-rhumb": "static-1.16611",
  "reporting-data": "static-1.67275",
  "reporting-testing-lib": "static-1.9208",
  "reporting-visualizations": "static-1.59351",
  "tinymce": "static-6.5",
  "ui-addon-draggable": "static-3.4717",
  "webpack-env": "static-1.54",
  "atom": "static-1.5019",
  "autolinker": "static-3.11",
  "avatar-components": "static-1.2444",
  "classnames": "static-2.10",
  "cssUtils": "static-1.778",
  "customer-data-filters-ui": "static-1.39554",
  "customer-data-objects": "static-1.7609",
  "customer-data-property-utils": "static-1.8031",
  "data-fetching-client": "static-1.9622",
  "enviro": "static-4.428",
  "FireAlarmUi": "static-1.4469",
  "flux-actions": "static-1.330",
  "FormsCommonComponents": "static-1.85682",
  "FormUrlGenerator": "static-2.4667",
  "foundations-components": "static-1.7821",
  "hs-lodash": "static-4.45",
  "hubspot-url-utils": "static-1.4049",
  "HubStyle": "static-2.11716",
  "icons": "static-2.643",
  "immutable": "static-2.77",
  "isMobile": "static-1.7",
  "js-cookie": "static-1.18",
  "laboratory-lib": "static-3.7106",
  "metrics-js": "static-1.9542",
  "PatternValidationJS": "static-1.437",
  "pdf-js": "static-2.49",
  "PortalIdParser": "static-2.388",
  "property-description-translator": "static-1.3795",
  "property-translator": "static-1.5350",
  "quartz-config": "static-1.727",
  "quartz-core": "static-1.6168",
  "quick-fetch": "static-1.3872",
  "raven": "static-3.5829",
  "react-dom": "static-7.85",
  "react-immutable-proptypes": "static-2.8",
  "react-input-autosize": "static-2.17",
  "react-select-plus": "static-1.103",
  "react-utils": "static-2.5298",
  "react-virtualized": "static-2.97",
  "redux": "static-4.16",
  "redux-thunk": "static-2.43",
  "reference-resolvers": "static-1.8117",
  "reference-resolvers-lite": "static-1.8041",
  "report-customization-components": "static-1.12982",
  "reporting-enablement": "static-1.22708",
  "reporting-reports": "static-1.66953",
  "reporting-snowflake": "static-1.55893",
  "reporting-ui-components": "static-2.64546",
  "reselect": "static-2.16",
  "rpc-client-utils": "static-1.4595",
  "sales-content-partitioning": "static-1.8884",
  "SalesContentIndexUI": "static-3.9160",
  "sanitize": "static-1.4420",
  "sanitize-text": "static-1.8091",
  "self-service-api": "static-1.10193",
  "SharedI18nStrings": "static-1.182",
  "SharedLegalStrings": "static-1.1694",
  "signup-constants": "static-1.18739",
  "signup-ui-lego-core": "static-1.20749",
  "signup-ui-url-generator": "static-2.7985",
  "styled-components": "static-2.88",
  "StyleGuideUI": "static-3.486",
  "superstore": "static-1.4714",
  "transmute": "static-2.85",
  "ui-addon-form-validation": "static-1.10936",
  "ui-addon-i18n": "static-1.11098",
  "ui-addon-react-router-dom": "static-1.9493",
  "ui-addon-upgrades": "static-9.17906",
  "ui-asset-management-lib": "static-1.10949",
  "ui-images": "static-2.1138",
  "UIComponents": "static-3.8355",
  "usage-tracker": "static-1.7285",
  "usage-tracker-container": "static-1.7275",
  "usage-tracker-core": "static-1.7135",
  "usage-tracker-public": "static-1.7096",
  "viral-links-lib": "static-1.6999",
  "hs-promise-rejection-tracking": "static-1.5489",
  "raven-hubspot": "static-1.6136",
  "hoist-non-react-statics": "static-3.9",
  "bend-plugin-trellis-migration": "static-1.3358",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3226",
  "quartz-webpack": "static-1.3173",
  "ai-components-ui-library": "static-1.8791",
  "amplitude-session-replay-browser": "static-1.58",
  "foundations-assets": "static-1.4803",
  "foundations-theming": "static-1.4363",
  "quartz-auth": "static-1.624",
  "ui-business-units-lib": "static-1.8994",
  "usage-tracker-session-replay": "static-1.4971",
  "foundations-theming-base": "static-1.3348",
  "HeadJS": "static-2.740",
  "framer-motion": "static-1.70",
  "hs-test-utils-bend-plugin": "static-1.3073",
  "msw": "static-1.39",
  "testing-library": "static-1.150",
  "hs-locale-management": "static-1.39",
  "i18n-data": "static-1.220",
  "moment-timezone": "static-5.81",
  "jasmine": "static-4.4272",
  "csstype": "static-1.50",
  "quartz-head": "static-1.614",
  "web-vitals": "static-1.3",
  "frontend-preferences-client": "static-1.7874",
  "graphql": "static-1.80",
  "immer": "static-1.33",
  "inbound-db-meta-service-client": "static-1.3546",
  "persist-promise": "static-1.3655",
  "quartz-i18n": "static-1.624",
  "reporting-client-types": "static-1.2460",
  "foundations-components-legacy": "static-1.846",
  "hs-story-utils": "static-1.9376",
  "react-flip-move": "static-1.68",
  "hub-http-shared-msw-handlers": "static-1.9834",
  "hubspotter-http": "static-1.4607",
  "sassPrefix": "static-1.155",
  "conversations-skeleton-state": "static-1.7196",
  "crm-message-bus": "static-1.42834",
  "customer-data-filters-ui-msw-helpers": "static-1.21989",
  "customer-data-objects-ui-components": "static-1.12971",
  "customer-data-reference-ui-components": "static-1.13105",
  "customer-data-ui-utilities": "static-1.9774",
  "framework-builder-read-service-client": "static-1.3965",
  "framework-data-schema-quick-fetch": "static-1.6730",
  "framework-data-schema-resolvers": "static-1.6825",
  "inbound-db-properties-service-client": "static-1.3796",
  "multi-account-reference-resolvers": "static-1.926",
  "onboarding-tours": "static-1.16493",
  "reporting-datasets-permissions-lib": "static-1.13505",
  "ui-addon-teams": "static-1.21474",
  "apollo-stack-hubspot": "static-3.84",
  "fast-json-stable-stringify": "static-1.4",
  "ContentUtils": "static-1.68196",
  "customer-data-properties": "static-1.51353",
  "forms-ai-lib": "static-1.4230",
  "forms-utils-lib": "static-1.12473",
  "foundations-components-test-utils": "static-1.5304",
  "react-dnd-compat": "static-1.4567",
  "react-tinymce": "static-1.55082",
  "tinymce-config": "static-2.54208",
  "ui-gdpr-components": "static-1.10294",
  "underscore": "static-1.8",
  "bend-plugin-foundations-components": "static-1.4090",
  "floating-ui": "static-1.54",
  "react-aria": "static-1.64",
  "react-create-root-preference": "static-1.9",
  "tanstack-table": "static-1.53",
  "trellis-assets": "static-1.1651",
  "ui-fonts": "static-1.670",
  "dispatcher": "static-1.135",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.826",
  "mobile-manifest-mixins": "static-1.514",
  "module-federation": "static-1.21",
  "quartz-routing": "static-1.379",
  "quartz-test": "static-1.624",
  "quartz-tracking": "static-1.328",
  "batch-promise": "static-1.1498",
  "external-options-client-types": "static-1.4114",
  "react-colorpicker": "static-2.10158",
  "copilot-toolkit": "static-1.10967",
  "data-quality-ui-library": "static-1.12740",
  "html-to-image": "static-1.52",
  "onboarding-scopes": "static-1.6410",
  "reporting-action-components": "static-1.41147",
  "reporting-filters": "static-1.169",
  "reporting-insights-lib": "static-1.1566",
  "reporting-plugins": "static-1.10200",
  "ui-addon-draggable-compat": "static-2.4202",
  "ui-addon-opt": "static-4.8321",
  "zustand": "static-1.72",
  "growth-payments-core": "static-1.25202",
  "hubspot-apollo-client": "static-1.4824",
  "bend-plugin-chirp-manifest": "static-1.5",
  "chirp-fetch": "static-1.1833",
  "sales-templates-service-types-lib": "static-1.4123",
  "merchandise-lib": "static-1.262",
  "emoji-regex": "static-1.7",
  "purchase-motions-components": "static-1.5784",
  "salesImages": "static-1.524",
  "ts-schema": "static-1.4033",
  "nested-table": "static-1.173",
  "timezone-utils": "static-2.5191",
  "bender-build-tools": "static-1.3123",
  "chatspot-core": "static-1.21018",
  "bend-plugin-foundations-theming": "static-1.2846",
  "stylex": "static-1.31",
  "hubspotter-http-shared-msw-handlers": "static-1.9832",
  "react-immutable-render-mixin": "static-1.9",
  "conditional-properties-service-client": "static-1.3752",
  "crm-pipelines-api-client-types": "static-1.4098",
  "multi-currency-client-types": "static-1.3647",
  "getting-started-shared-tasks": "static-1.18339",
  "growth-data-modal": "static-1.5340",
  "growth-onboarding-confetti": "static-1.3015",
  "growth-onboarding-next-action-utils": "static-1.1750",
  "navigation-components": "static-1.17837",
  "onboarding-tours-client": "static-1.4707",
  "onboarding-tours-utils": "static-1.559",
  "ui-shepherd-react": "static-3.10096",
  "ui-shepherd-tracker": "static-1.7477",
  "ui-universal-auth": "static-1.8908",
  "user-context": "static-1.5048",
  "cms-field-types": "static-1.4758",
  "content-icons-ui": "static-1.2211",
  "integrations-lib": "static-1.15939",
  "calling-global-api": "static-1.64313",
  "calling-internal-common": "static-1.31248",
  "calling-lifecycle-internal": "static-1.65695",
  "calling-lifecycle-messages": "static-1.57989",
  "commerce-products-lib": "static-1.9319",
  "crm-links": "static-1.6228",
  "customer-data-properties-shared-msw-handlers": "static-1.9161",
  "file-manager-components": "static-1.23458",
  "google-libphonenumber": "static-1.36",
  "hs-resources": "static-1.91",
  "inbounddb-objects-service-types": "static-1.4179",
  "meetings-icalendar-utils-lib": "static-1.578",
  "object-builder-ui-client": "static-1.48548",
  "pipeline-validation-client-types": "static-1.3921",
  "property-value-citations": "static-1.1967",
  "pulse": "static-1.502",
  "smart-property-lib": "static-1.6664",
  "tiered-pricing": "static-1.1091",
  "ui-addon-iframeable": "static-1.9000",
  "final-form": "static-1.68",
  "redux-mock-store": "static-1.8",
  "redux-toolkit": "static-1.7",
  "rich-text-lib": "static-1.19733",
  "tinymce-themes": "static-1.56178",
  "data-token-picker": "static-1.16306",
  "hub-http-contrib": "static-1.2988",
  "interframe": "static-3.4709",
  "tinymce-data": "static-1.40293",
  "tinymce-plugins": "static-1.57322",
  "ui-addon-sales-email": "static-1.5158",
  "history": "static-4.47",
  "react-router-dom": "static-5.26",
  "magpie-lib": "static-1.5524",
  "magpie-types": "static-1.4984",
  "simple-logging-lib": "static-1.2996",
  "content-assistance-lib": "static-1.7667",
  "dashboard-lib": "static-1.81303",
  "ExportDialog": "static-6.10340",
  "hubspot-prosemirror": "static-1.18073",
  "hubspot-prosemirror-plugins": "static-1.18065",
  "prosemirror": "static-1.13",
  "share-with-third-party-component-lib": "static-1.8644",
  "campaign-roi-lib": "static-1.8911",
  "feedback-loader": "static-1.29195",
  "apollo-link-hub-http": "static-2.4596",
  "hubspot-apollo-cache": "static-1.283",
  "purchase-motions-api": "static-1.5787",
  "trials-service-types": "static-1.3850",
  "react-window": "static-1.13",
  "ts-utils-lib": "static-1.119",
  "markdown-it": "static-1.6",
  "onboarding-data-sync-lib": "static-1.1868",
  "growth-onboarding-next-action-components": "static-1.1778",
  "user-context-client": "static-1.4557",
  "idb-keyval": "static-1.42",
  "nest": "static-1.172",
  "reactive-lib": "static-1.669",
  "unified-auth-core-lib": "static-1.703",
  "getting-started-shared-tasks-store": "static-1.17457",
  "integrations-error-boundary-lib": "static-1.13354",
  "integrations-tracking-lib": "static-1.5545",
  "native-integrations-shared-strings": "static-1.7731",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10319",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.422",
  "calling-error-reporting": "static-1.31254",
  "shared-worker-versioning": "static-1.10985",
  "calling-usage-tracker": "static-1.6489",
  "voice-sms-access-library": "static-1.756",
  "customer-data-tracking": "static-1.6833",
  "commerce-permissions": "static-1.713",
  "products-iframe-lib": "static-1.7764",
  "products-ui-components-shared-msw-handlers": "static-1.10216",
  "location-customization-utils-lib": "static-1.9076",
  "apollo-dlb": "static-3.86",
  "immerable": "static-1.4101",
  "video-components-external": "static-1.11087",
  "video-data-lib": "static-1.34745",
  "bend-plugin-pulse": "static-1.5",
  "directed-graph": "static-1.883",
  "event-emitter": "static-1.896",
  "fast-json-patch": "static-1.61",
  "data-agent-kit": "static-1.106",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9917",
  "fsm": "static-1.3680",
  "policy-lib": "static-1.6719",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9980",
  "navigation-messaging": "static-1.7164",
  "FileManagerLib": "static-1.39098",
  "NamespacedHubStyle": "static-2.9018",
  "FileManagerCore": "static-1.38957",
  "codemirror": "static-5.93",
  "layout-dnd-components": "static-1.12336",
  "layout-dnd-utils": "static-1.11311",
  "react-codemirror": "static-1.10571",
  "ui-addon-emoji-picker": "static-1.9835",
  "ui-brand-identity-lib": "static-1.14986",
  "ui-addon-video-player": "static-1.8646",
  "ui-coaching-tips": "static-1.28387",
  "redux-actions": "static-3.7",
  "knowledge-content-types": "static-1.8479",
  "payment-link-components": "static-1.23372",
  "EmailSignatureEditor": "static-1.24252",
  "InboxConnectUtils": "static-4.14643",
  "universal-page-editor-lib": "static-1.2959",
  "google-sheets-integration-lib": "static-1.71",
  "microsoft-drive-integration-lib": "static-1.182",
  "calling-orchestration-schema": "static-1.35533",
  "sales-views-client-types": "static-1.4211",
  "crm-record-cards-service-types": "static-1.3566",
  "content-media-composition-data-lib": "static-1.12062",
  "content-media-compositions": "static-2.16069",
  "media-bridge-lib": "static-1.18829",
  "trellis-story-utils": "static-1.4463",
  "storybook-react": "static-1.31",
  "audio-components": "static-1.5832",
  "FileManagerImages": "static-1.36609",
  "video-components": "static-1.13090",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4479",
  "video-embed": "static-1.35579",
  "diff-match-patch": "static-1.7",
  "ContentData": "static-1.68271",
  "layout-data-lib": "static-1.9636",
  "browser-eslint": "static-2.57",
  "growth-onboarding-feedback-components": "static-1.6531",
  "commerce-tours-lib": "static-1.5991",
  "growth-onboarding-reliability": "static-1.5029",
  "sales-checkout-service-client": "static-1.3586",
  "draft-convert": "static-2.71",
  "draft-extend": "static-3.73",
  "draft-js": "static-5.76",
  "draft-plugins": "static-2.21572",
  "sales-email-signature-service-client": "static-1.3790",
  "social-insights-client-types": "static-1.21926",
  "outpost": "static-1.4136",
  "advanced-menus-core": "static-1.15040",
  "advanced-menus-lib": "static-1.11994",
  "ui-memberships-settings-lib": "static-1.33892",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15039",
  "simple-menus-lib": "static-1.16556"
},
  depPathPrefixes: {
  "documents-public-ui": "/documents-public-ui/static-1.34372",
  "client-types": "/client-types/static-1.459",
  "documents-lib": "/documents-lib/static-1.34377",
  "emoji-mart": "/emoji-mart/static-3.4",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2079",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "head-dlb": "/head-dlb/static-1.4938",
  "highcharts": "/highcharts/static-8.102",
  "hs-promise-utils": "/hs-promise-utils/static-1.5541",
  "hs-test-utils": "/hs-test-utils/static-1.7962",
  "hub-http": "/hub-http/static-1.6168",
  "hubspot-dlb": "/hubspot-dlb/static-2.1832",
  "HubStyleTokens": "/HubStyleTokens/static-2.11408",
  "I18n": "/I18n/static-7.1610",
  "jasmine-immutable": "/jasmine-immutable/static-1.2966",
  "jasmine-runner": "/jasmine-runner/static-1.6417",
  "lodash": "/lodash/static-1.3",
  "quartz": "/quartz/static-1.6949",
  "react": "/react/static-7.184",
  "react-dlb": "/react-dlb/static-1.77",
  "react-dnd": "/react-dnd/static-3.19",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-3.7",
  "react-redux": "/react-redux/static-7.70",
  "react-rhumb": "/react-rhumb/static-1.16611",
  "reporting-data": "/reporting-data/static-1.67275",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.9208",
  "reporting-visualizations": "/reporting-visualizations/static-1.59351",
  "tinymce": "/tinymce/static-6.5",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4717",
  "webpack-env": "/webpack-env/static-1.54",
  "atom": "/atom/static-1.5019",
  "autolinker": "/autolinker/static-3.11",
  "avatar-components": "/avatar-components/static-1.2444",
  "classnames": "/classnames/static-2.10",
  "cssUtils": "/cssUtils/static-1.778",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.39554",
  "customer-data-objects": "/customer-data-objects/static-1.7609",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8031",
  "data-fetching-client": "/data-fetching-client/static-1.9622",
  "enviro": "/enviro/static-4.428",
  "FireAlarmUi": "/FireAlarmUi/static-1.4469",
  "flux-actions": "/flux-actions/static-1.330",
  "FormsCommonComponents": "/FormsCommonComponents/static-1.85682",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4667",
  "foundations-components": "/foundations-components/static-1.7821",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4049",
  "HubStyle": "/HubStyle/static-2.11716",
  "icons": "/icons/static-2.643",
  "immutable": "/immutable/static-2.77",
  "isMobile": "/isMobile/static-1.7",
  "js-cookie": "/js-cookie/static-1.18",
  "laboratory-lib": "/laboratory-lib/static-3.7106",
  "metrics-js": "/metrics-js/static-1.9542",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "pdf-js": "/pdf-js/static-2.49",
  "PortalIdParser": "/PortalIdParser/static-2.388",
  "property-description-translator": "/property-description-translator/static-1.3795",
  "property-translator": "/property-translator/static-1.5350",
  "quartz-config": "/quartz-config/static-1.727",
  "quartz-core": "/quartz-core/static-1.6168",
  "quick-fetch": "/quick-fetch/static-1.3872",
  "raven": "/raven/static-3.5829",
  "react-dom": "/react-dom/static-7.85",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "react-select-plus": "/react-select-plus/static-1.103",
  "react-utils": "/react-utils/static-2.5298",
  "react-virtualized": "/react-virtualized/static-2.97",
  "redux": "/redux/static-4.16",
  "redux-thunk": "/redux-thunk/static-2.43",
  "reference-resolvers": "/reference-resolvers/static-1.8117",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8041",
  "report-customization-components": "/report-customization-components/static-1.12982",
  "reporting-enablement": "/reporting-enablement/static-1.22708",
  "reporting-reports": "/reporting-reports/static-1.66953",
  "reporting-snowflake": "/reporting-snowflake/static-1.55893",
  "reporting-ui-components": "/reporting-ui-components/static-2.64546",
  "reselect": "/reselect/static-2.16",
  "rpc-client-utils": "/rpc-client-utils/static-1.4595",
  "sales-content-partitioning": "/sales-content-partitioning/static-1.8884",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.9160",
  "sanitize": "/sanitize/static-1.4420",
  "sanitize-text": "/sanitize-text/static-1.8091",
  "self-service-api": "/self-service-api/static-1.10193",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "SharedLegalStrings": "/SharedLegalStrings/static-1.1694",
  "signup-constants": "/signup-constants/static-1.18739",
  "signup-ui-lego-core": "/signup-ui-lego-core/static-1.20749",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7985",
  "styled-components": "/styled-components/static-2.88",
  "StyleGuideUI": "/StyleGuideUI/static-3.486",
  "superstore": "/superstore/static-1.4714",
  "transmute": "/transmute/static-2.85",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10936",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11098",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9493",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17906",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10949",
  "ui-images": "/ui-images/static-2.1138",
  "UIComponents": "/UIComponents/static-3.8355",
  "usage-tracker": "/usage-tracker/static-1.7285",
  "usage-tracker-container": "/usage-tracker-container/static-1.7275",
  "usage-tracker-core": "/usage-tracker-core/static-1.7135",
  "usage-tracker-public": "/usage-tracker-public/static-1.7096",
  "viral-links-lib": "/viral-links-lib/static-1.6999",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5489",
  "raven-hubspot": "/raven-hubspot/static-1.6136",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3358",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3226",
  "quartz-webpack": "/quartz-webpack/static-1.3173",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8791",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.58",
  "foundations-assets": "/foundations-assets/static-1.4803",
  "foundations-theming": "/foundations-theming/static-1.4363",
  "quartz-auth": "/quartz-auth/static-1.624",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8994",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4971",
  "foundations-theming-base": "/foundations-theming-base/static-1.3348",
  "HeadJS": "/HeadJS/static-2.740",
  "framer-motion": "/framer-motion/static-1.70",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3073",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.150",
  "hs-locale-management": "/hs-locale-management/static-1.39",
  "i18n-data": "/i18n-data/static-1.220",
  "moment-timezone": "/moment-timezone/static-5.81",
  "jasmine": "/jasmine/static-4.4272",
  "csstype": "/csstype/static-1.50",
  "quartz-head": "/quartz-head/static-1.614",
  "web-vitals": "/web-vitals/static-1.3",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7874",
  "graphql": "/graphql/static-1.80",
  "immer": "/immer/static-1.33",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3546",
  "persist-promise": "/persist-promise/static-1.3655",
  "quartz-i18n": "/quartz-i18n/static-1.624",
  "reporting-client-types": "/reporting-client-types/static-1.2460",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.846",
  "hs-story-utils": "/hs-story-utils/static-1.9376",
  "react-flip-move": "/react-flip-move/static-1.68",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9834",
  "hubspotter-http": "/hubspotter-http/static-1.4607",
  "sassPrefix": "/sassPrefix/static-1.155",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7196",
  "crm-message-bus": "/crm-message-bus/static-1.42834",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21989",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12971",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13105",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9774",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3965",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6730",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6825",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3796",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.926",
  "onboarding-tours": "/onboarding-tours/static-1.16493",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13505",
  "ui-addon-teams": "/ui-addon-teams/static-1.21474",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "ContentUtils": "/ContentUtils/static-1.68196",
  "customer-data-properties": "/customer-data-properties/static-1.51353",
  "forms-ai-lib": "/forms-ai-lib/static-1.4230",
  "forms-utils-lib": "/forms-utils-lib/static-1.12473",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5304",
  "react-dnd-compat": "/react-dnd-compat/static-1.4567",
  "react-tinymce": "/react-tinymce/static-1.55082",
  "tinymce-config": "/tinymce-config/static-2.54208",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10294",
  "underscore": "/underscore/static-1.8",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4090",
  "floating-ui": "/floating-ui/static-1.54",
  "react-aria": "/react-aria/static-1.64",
  "react-create-root-preference": "/react-create-root-preference/static-1.9",
  "tanstack-table": "/tanstack-table/static-1.53",
  "trellis-assets": "/trellis-assets/static-1.1651",
  "ui-fonts": "/ui-fonts/static-1.670",
  "dispatcher": "/dispatcher/static-1.135",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.826",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.514",
  "module-federation": "/module-federation/static-1.21",
  "quartz-routing": "/quartz-routing/static-1.379",
  "quartz-test": "/quartz-test/static-1.624",
  "quartz-tracking": "/quartz-tracking/static-1.328",
  "batch-promise": "/batch-promise/static-1.1498",
  "external-options-client-types": "/external-options-client-types/static-1.4114",
  "react-colorpicker": "/react-colorpicker/static-2.10158",
  "copilot-toolkit": "/copilot-toolkit/static-1.10967",
  "data-quality-ui-library": "/data-quality-ui-library/static-1.12740",
  "html-to-image": "/html-to-image/static-1.52",
  "onboarding-scopes": "/onboarding-scopes/static-1.6410",
  "reporting-action-components": "/reporting-action-components/static-1.41147",
  "reporting-filters": "/reporting-filters/static-1.169",
  "reporting-insights-lib": "/reporting-insights-lib/static-1.1566",
  "reporting-plugins": "/reporting-plugins/static-1.10200",
  "ui-addon-draggable-compat": "/ui-addon-draggable-compat/static-2.4202",
  "ui-addon-opt": "/ui-addon-opt/static-4.8321",
  "zustand": "/zustand/static-1.72",
  "growth-payments-core": "/growth-payments-core/static-1.25202",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4824",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.5",
  "chirp-fetch": "/chirp-fetch/static-1.1833",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.4123",
  "merchandise-lib": "/merchandise-lib/static-1.262",
  "emoji-regex": "/emoji-regex/static-1.7",
  "purchase-motions-components": "/purchase-motions-components/static-1.5784",
  "salesImages": "/salesImages/static-1.524",
  "ts-schema": "/ts-schema/static-1.4033",
  "nested-table": "/nested-table/static-1.173",
  "timezone-utils": "/timezone-utils/static-2.5191",
  "bender-build-tools": "/bender-build-tools/static-1.3123",
  "chatspot-core": "/chatspot-core/static-1.21018",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2846",
  "stylex": "/stylex/static-1.31",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9832",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3752",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4098",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3647",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.18339",
  "growth-data-modal": "/growth-data-modal/static-1.5340",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3015",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1750",
  "navigation-components": "/navigation-components/static-1.17837",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4707",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.559",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10096",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7477",
  "ui-universal-auth": "/ui-universal-auth/static-1.8908",
  "user-context": "/user-context/static-1.5048",
  "cms-field-types": "/cms-field-types/static-1.4758",
  "content-icons-ui": "/content-icons-ui/static-1.2211",
  "integrations-lib": "/integrations-lib/static-1.15939",
  "calling-global-api": "/calling-global-api/static-1.64313",
  "calling-internal-common": "/calling-internal-common/static-1.31248",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65695",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57989",
  "commerce-products-lib": "/commerce-products-lib/static-1.9319",
  "crm-links": "/crm-links/static-1.6228",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.9161",
  "file-manager-components": "/file-manager-components/static-1.23458",
  "google-libphonenumber": "/google-libphonenumber/static-1.36",
  "hs-resources": "/hs-resources/static-1.91",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4179",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.578",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.48548",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3921",
  "property-value-citations": "/property-value-citations/static-1.1967",
  "pulse": "/pulse/static-1.502",
  "smart-property-lib": "/smart-property-lib/static-1.6664",
  "tiered-pricing": "/tiered-pricing/static-1.1091",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9000",
  "final-form": "/final-form/static-1.68",
  "redux-mock-store": "/redux-mock-store/static-1.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "rich-text-lib": "/rich-text-lib/static-1.19733",
  "tinymce-themes": "/tinymce-themes/static-1.56178",
  "data-token-picker": "/data-token-picker/static-1.16306",
  "hub-http-contrib": "/hub-http-contrib/static-1.2988",
  "interframe": "/interframe/static-3.4709",
  "tinymce-data": "/tinymce-data/static-1.40293",
  "tinymce-plugins": "/tinymce-plugins/static-1.57322",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5158",
  "history": "/history/static-4.47",
  "react-router-dom": "/react-router-dom/static-5.26",
  "magpie-lib": "/magpie-lib/static-1.5524",
  "magpie-types": "/magpie-types/static-1.4984",
  "simple-logging-lib": "/simple-logging-lib/static-1.2996",
  "content-assistance-lib": "/content-assistance-lib/static-1.7667",
  "dashboard-lib": "/dashboard-lib/static-1.81303",
  "ExportDialog": "/ExportDialog/static-6.10340",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.18073",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.18065",
  "prosemirror": "/prosemirror/static-1.13",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8644",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8911",
  "feedback-loader": "/feedback-loader/static-1.29195",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4596",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.283",
  "purchase-motions-api": "/purchase-motions-api/static-1.5787",
  "trials-service-types": "/trials-service-types/static-1.3850",
  "react-window": "/react-window/static-1.13",
  "ts-utils-lib": "/ts-utils-lib/static-1.119",
  "markdown-it": "/markdown-it/static-1.6",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.1868",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.1778",
  "user-context-client": "/user-context-client/static-1.4557",
  "idb-keyval": "/idb-keyval/static-1.42",
  "nest": "/nest/static-1.172",
  "reactive-lib": "/reactive-lib/static-1.669",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.703",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.17457",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.13354",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5545",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7731",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10319",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.422",
  "calling-error-reporting": "/calling-error-reporting/static-1.31254",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10985",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6489",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.756",
  "customer-data-tracking": "/customer-data-tracking/static-1.6833",
  "commerce-permissions": "/commerce-permissions/static-1.713",
  "products-iframe-lib": "/products-iframe-lib/static-1.7764",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.10216",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9076",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "immerable": "/immerable/static-1.4101",
  "video-components-external": "/video-components-external/static-1.11087",
  "video-data-lib": "/video-data-lib/static-1.34745",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.5",
  "directed-graph": "/directed-graph/static-1.883",
  "event-emitter": "/event-emitter/static-1.896",
  "fast-json-patch": "/fast-json-patch/static-1.61",
  "data-agent-kit": "/data-agent-kit/static-1.106",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9917",
  "fsm": "/fsm/static-1.3680",
  "policy-lib": "/policy-lib/static-1.6719",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9980",
  "navigation-messaging": "/navigation-messaging/static-1.7164",
  "FileManagerLib": "/FileManagerLib/static-1.39098",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9018",
  "FileManagerCore": "/FileManagerCore/static-1.38957",
  "codemirror": "/codemirror/static-5.93",
  "layout-dnd-components": "/layout-dnd-components/static-1.12336",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.11311",
  "react-codemirror": "/react-codemirror/static-1.10571",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9835",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.14986",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8646",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.28387",
  "redux-actions": "/redux-actions/static-3.7",
  "knowledge-content-types": "/knowledge-content-types/static-1.8479",
  "payment-link-components": "/payment-link-components/static-1.23372",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.24252",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14643",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2959",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.71",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.182",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35533",
  "sales-views-client-types": "/sales-views-client-types/static-1.4211",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3566",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.12062",
  "content-media-compositions": "/content-media-compositions/static-2.16069",
  "media-bridge-lib": "/media-bridge-lib/static-1.18829",
  "trellis-story-utils": "/trellis-story-utils/static-1.4463",
  "storybook-react": "/storybook-react/static-1.31",
  "audio-components": "/audio-components/static-1.5832",
  "FileManagerImages": "/FileManagerImages/static-1.36609",
  "video-components": "/video-components/static-1.13090",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4479",
  "video-embed": "/video-embed/static-1.35579",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "ContentData": "/ContentData/static-1.68271",
  "layout-data-lib": "/layout-data-lib/static-1.9636",
  "browser-eslint": "/browser-eslint/static-2.57",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6531",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5991",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5029",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3586",
  "draft-convert": "/draft-convert/static-2.71",
  "draft-extend": "/draft-extend/static-3.73",
  "draft-js": "/draft-js/static-5.76",
  "draft-plugins": "/draft-plugins/static-2.21572",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3790",
  "social-insights-client-types": "/social-insights-client-types/static-1.21926",
  "outpost": "/outpost/static-1.4136",
  "advanced-menus-core": "/advanced-menus-core/static-1.15040",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11994",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33892",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15039",
  "simple-menus-lib": "/simple-menus-lib/static-1.16556"
}
};
